import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import Routes from './Routes';
import './assets/css/App.css';
import theme from './theme';
import { ThemeProvider} from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

const browserHistory = createBrowserHistory();

function App() {
  return (
      <Router history={browserHistory}>
          <ThemeProvider theme={theme}>
              <CssBaseline />
              <div className="app-container">
                  <ReactNotifications />
                  <Routes />
              </div>
          </ThemeProvider>
      </Router>
  );
}

export default App;